import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import configureStore, { history } from './store/configureStore';
import Root from './containers/Root';
import AuthUtils from './utils/AuthUtils';
import * as ActionTypes from './actions/types';

import 'bootstrap/dist/css/bootstrap.min.css';

const store = configureStore();

if (AuthUtils.getAccessToken() || AuthUtils.getRefreshToken()) {
  store.dispatch({ type: ActionTypes.LOGIN_SUCCESS });
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Root store={store} />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);
